import { site } from "../content/site";
import { Reveal } from "./Reveal";
import { StoreButtons } from "./StoreButtons";

export const FinalCta = () => (
  <section id="download" className="border-t border-gray-200 bg-gray-50" data-testid="final-cta-section">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-24">
      <Reveal className="max-w-2xl">
        <h2 data-testid="final-cta-heading" className="font-heading text-3xl font-bold tracking-tight text-gray-900 md:text-4xl">
          {site.finalCta.heading}
        </h2>
        <p className="mt-4 text-base leading-relaxed text-gray-600 md:text-lg">{site.finalCta.subcopy}</p>
        <div className="mt-8">
          <StoreButtons />
        </div>
      </Reveal>
    </div>
  </section>
);
